<div class="report-embed" #reportRef [style.opacity]="loading ? 0 : 1"></div>
<app-loading-icon [loading]="loading" [slow]="false"></app-loading-icon>
